module.exports = __webpack_public_path__ + "img/logo-white.22d601c1.png";